import {
  type CommonCustomErrorResponse,
  type ProblemDetails,
  type WebV1SurveysCloseCreateData,
  Surveys
} from '@credit-web/services/product-journey-girar'
import { type AllServicesQueryParams, type TransformTypesToCamelCase } from '@credit-web/services/types'

// eslint-disable-next-line no-restricted-imports
import { type UseMutationRequestOptions, useMutationRequest } from '~/ui/hooks/utils/service/use-query-request'

export type UseSurveysCloseCreateResponse = TransformTypesToCamelCase<WebV1SurveysCloseCreateData>
type UseSurveysCloseCreateVariables = { surveyKey: string; query: AllServicesQueryParams }

/**
 * No description
 *
 * @tags hook
 * @name useSurveysCloseCreate
 * @summary Close survey by Key
 * @request POST:/api/web/v1/surveys/{key}/close
 * @secure
 * @response `200` `WebV1SurveysCloseCreateData` OK
 * @response `204` `void` No Content
 * @response `400` `CommonCustomErrorResponse` Bad Request
 * @response `403` `ProblemDetails` Forbidden
 */
export const useSurveysCloseCreate = (
  mutationOptions?: UseMutationRequestOptions<
    UseSurveysCloseCreateResponse,
    CommonCustomErrorResponse | ProblemDetails,
    false,
    UseSurveysCloseCreateVariables
  >
) => {
  return useMutationRequest<
    UseSurveysCloseCreateResponse,
    CommonCustomErrorResponse | ProblemDetails,
    false,
    UseSurveysCloseCreateVariables
  >(['webV1SurveysCloseCreate'], ({ surveyKey, query }) => Surveys.webV1SurveysCloseCreate(surveyKey, { query }), {
    ...mutationOptions
  })
}
